import { Link } from 'react-router-dom';
import { getArticleNeighbors } from '../../lib/content';
import { articlePath } from '../../lib/routes';
import type { Profile } from '../../types/profile';

export function ArticleNavigation({ profile, articleId }: { profile: Profile; articleId: string }) {
  const { previous, next } = getArticleNeighbors(profile, articleId);
  if (!previous && !next) return null;

  return (
    <nav className="article-navigation" aria-label="Navegação entre artigos">
      {previous ? (
        <Link className="article-nav-card previous" to={articlePath(profile, previous.meta.category, previous.meta.slug)}>
          <span>← Anterior</span>
          <strong>{previous.meta.title}</strong>
        </Link>
      ) : <span />}
      {next ? (
        <Link className="article-nav-card next" to={articlePath(profile, next.meta.category, next.meta.slug)}>
          <span>Próximo →</span>
          <strong>{next.meta.title}</strong>
        </Link>
      ) : null}
    </nav>
  );
}
